import React, { useState, useRef } from "react";
import ArchiveTable from "../components/ArchiveTable";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "react-multi-date-picker/styles/colors/purple.css";
import "react-multi-date-picker/styles/layouts/mobile.css";
import ReactPaginate from "react-paginate";
import { apiFetch } from "../api/client";
import playIcon from "../assets/icons/Play.svg";
import closeIcon from "../assets/icons/closeRing.svg";

const persianToday = () =>
  new DateObject({ calendar: persian, locale: persian_fa }).set("date", new Date());

/** Earliest selectable archive date (adjust if older data exists in DB). */
const archiveMinDate = () =>
  new DateObject({ calendar: persian, locale: persian_fa }).subtract(15, "year");

const ArchivePage = ({ currencies, coins }) => {
  const [endDate, setEndDate] = useState(persianToday);
  const [startDate, setStartDate] = useState(() =>
    persianToday().subtract(1, "day")
  );
  const [rateName, setRateName] = useState("");
  const [rates, setRates] = useState({ rows: [], count: 0 });
  const [currentRateName, setCurrentRateName] = useState("");
  const [types, setTypes] = useState("");
  const optionRef = useRef();
  const typeRef = useRef();
  const [currentPage, setCurrentPage] = useState(0); // Pagination starts at 0
  const [perPage] = useState(8); // Updated items per page

  const handleRates = async (e) => {
    e.preventDefault();
    if (!rateName) {
      return;
    }
    setCurrentRateName(rateName);

    try {
      // Set start and end dates with correct time boundaries
      const normalizedStartDate =
        startDate.set({ hour: 0, minute: 0, second: 0 }).unix * 1000;
      const normalizedEndDate =
        endDate.set({ hour: 23, minute: 59, second: 59 }).unix * 1000;

      const res = await apiFetch("/api/getArchive", {
        method: "POST",
        body: JSON.stringify({
          rateName,
          startDate: normalizedStartDate,
          endDate: normalizedEndDate,
          offset: 0,
        }),
      });

      const result = await res.json();
      setRates(result);
      setCurrentPage(0); // Reset pagination to the first page
    } catch (err) {
      console.error(err);
    }
  };

  const handlePageClick = async (data) => {
    const selectedPage = data.selected;
    const offset = selectedPage * perPage;
    console.log(offset);

    try {
      const res = await apiFetch("/api/getArchive", {
        method: "POST",
        body: JSON.stringify({
          rateName: currentRateName,
          startDate: startDate.unix * 1000,
          endDate: endDate.unix * 1000,
          offset,
        }),
      });

      const result = await res.json();
      setRates(result);
      setCurrentPage(selectedPage); // Update current page
    } catch (err) {
      console.error(err);
    }
  };

  const resetFilters = (e) => {
    e.preventDefault();
    setRateName("");
    optionRef.current.innerHTML = "ارز/سکه مورد نظر خود را انتخاب کنید";
    typeRef.current.innerHTML = "ارز/سکه";
    setStartDate(persianToday().subtract(1, "day"));
    setEndDate(persianToday());
    setRates({ rows: [], count: 0 });
    setCurrentPage(0);
  };

  const pageCount = Math.ceil(rates.count / perPage);

  return (
    <div className="archive-container">
      <div className="archive">
        <div className="archive-wrapper">
          <div className="title-util-wrapper">
            <div className="title">آرشیو مورد نظر خود را انتخاب کنید</div>
            <form className="utils-archive">
              <div className="dropdownContainer">
                <details>
                  <summary ref={typeRef}> ارز / سکه</summary>
                  <ul>
                    <li
                      className="select-option"
                      onClick={(e) => {
                        typeRef.current.innerHTML = e.target.innerHTML;
                        setTypes("ارز");
                        typeRef.current.click();
                      }}
                    >
                      ارز
                    </li>
                    <li
                      className="select-option"
                      onClick={(e) => {
                        typeRef.current.innerHTML = e.target.innerHTML;
                        setTypes("سکه");
                        typeRef.current.click();
                      }}
                    >
                      سکه
                    </li>
                  </ul>
                </details>
              </div>
              <div className="dropdownContainer">
                <details>
                  <summary ref={optionRef}>انتخاب ارز / سکه</summary>
                  <ul>
                    {types === "ارز"
                      ? currencies?.map((item) => (
                          <li
                            key={item.currency.id}
                            className="select-option"
                            onClick={(e) => {
                              optionRef.current.innerHTML = e.target.innerHTML;
                              setRateName(item.currency.name);
                              optionRef.current.click();
                            }}
                          >
                            {item.currency.name}
                          </li>
                        ))
                      : coins?.map((item) => (
                          <li
                            key={item.coin.id}
                            className="select-option"
                            onClick={(e) => {
                              optionRef.current.innerHTML = e.target.innerHTML;
                              setRateName(item.coin.name);
                              optionRef.current.click();
                            }}
                          >
                            {item.coin.name}
                          </li>
                        ))}
                  </ul>
                </details>
              </div>
              <DatePicker
                calendar={persian}
                locale={persian_fa}
                render={<input className="datepicker-input" />}
                value={startDate}
                onChange={setStartDate}
                maxDate={endDate}
                minDate={archiveMinDate()}
                placeholder="از تاریخ"
              />
              <DatePicker
                calendar={persian}
                locale={persian_fa}
                render={<input className="datepicker-input" />}
                value={endDate}
                onChange={setEndDate}
                minDate={startDate}
                maxDate={persianToday()}
                placeholder="تا تاریخ"
              />
              <div className="search-buttons">
                <button
                  type="submit"
                  className="search-btn play"
                  onClick={handleRates}
                >
                  <img src={playIcon} alt="play" />
                </button>
                <button className="search-btn" onClick={resetFilters}>
                  <img src={closeIcon} alt="close" />
                </button>
              </div>
            </form>
          </div>
          <section className="archive-table-wrapper">
            <ArchiveTable rates={rates} offset={currentPage * perPage} />
            {rates.count > 0 && (
              <ReactPaginate
                previousLabel={"قبل"}
                nextLabel={"بعد"}
                breakLabel={"..."}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                activeClassName={"active"}
                forcePage={currentPage} // Sync current page with state
              />
            )}
          </section>
        </div>
      </div>
    </div>
  );
};

export default ArchivePage;
